import React, { useState, useEffect, memo, useRef } from "react";
import Formsy from "formsy-react";
import { MySelect } from "../../Shared/Forms/Select";

import { Row, Col, Button, Spinner, UncontrolledAlert, Card, CardBody, CardHeader } from "reactstrap";
import { MdSave, MdClose, MdAdd } from "react-icons/md";
import { TextInput } from "../../Shared/Forms";
//import FoodLibraryDropDown from "./FoodLibraryDropDown";
import AsyncFoodLibraryDropDown from "./AsyncFoodLibraryDropDown";
import MealRoasterEditor from "../../Shared/Forms/MealRoasterEditor";
import FoodLibraryModal from "../../Shared/FoodLibraryModal";
const options = [
    { key: "BreakFast", value: 2 },
    { key: "Lunch", value: 3 },
    { key: "Dinner", value: 4 },
    { key: "Snack", value: 5 },
    // { key: "Others", value: 1 },
];
const DailyMealPlan = memo((props) => {
    const { submitted, submitting, totalNumDays, handleSubmit, formError, dailyReset, submitToAdmin } = props;
    const dailyMealFormRef = useRef("dailyMealForm");
    const [mealType, setMealTypes] = useState(options);
    const [days, setDays] = useState(1);
    const [breakFast, setBreakFast] = useState({ key: "BreakFast", value: null });
    const [lunch, setLunch] = useState({ key: "Lunch", value: null });
    const [snack, setSnack] = useState({ key: "Snack", value: null });
    const [dinner, setDinner] = useState({ key: "Dinner", value: null });
    const [others, setOthersMealType] = useState({ key: "Others", value: null });
    //disable the save button on load and after submission
    const [disableSaveButton, setDisableSaveButton] = useState(true);
    // when change on the meal plan type select
    const [newAddArray, setNewAddArray] = useState([]);
    // validation states
    const [canSubmit, setCanSubmit] = useState(false);
    const [showFoodItemModal, setShowFoodItemModal] = useState(false);
    //code for measurement.....
    const [foodItemsArry, setFoodItemsArry] = useState([]);
    const [lunchFoodItemsArry, setLunchFoodItemsArry] = useState([]);
    const [dinnerFoodItemsArry, setDinnerFoodItemsArry] = useState([]);
    const [snackFoodItemsArry, setSnackFoodItemsArry] = useState([]);
    const [breakFoodItemsQty, setBreakFoodItemsQty] = useState([]);
    const [lunchFoodItemsQty, setLunchFoodItemsQty] = useState([]);
    const [dinnerFoodItemsQty, setDinnerFoodItemsQty] = useState([]);
    const [snackFoodItemsQty, setSnackFoodItemsQty] = useState([]);
    const totalResetAfterSubmitting = () => {
        setNewAddArray([]);
        setFoodItemsArry([]);
        setLunchFoodItemsArry([]);
        setDinnerFoodItemsArry([]);
        setSnackFoodItemsArry([]);
        setDisableSaveButton(true);
        //add it back to setNutrients fields.
        setMealTypes([
            { key: "BreakFast", value: 2 },
            { key: "Lunch", value: 3 },
            { key: "Dinner", value: 4 },
            { key: "Snack", value: 5 },
            // { key: "Others", value: 1 },
        ]);
    };
    const showConfirmation = () => {
        setShowFoodItemModal(!showFoodItemModal);
    };
    const storeCalorieValue = (data, index, mealType) => {
        if (mealType === "BreakFastMeal") {
            let clonebreakArry = JSON.parse(JSON.stringify(breakFoodItemsQty));

            //look for the index on the arry and replaced it value at that index.
            for (let k = 0; k < foodItemsArry.length; k++) {
                // if(clonebreakArry[k])
                if (k === index) {
                    //check if undefined

                    clonebreakArry.splice(k, 1, data);

                    setBreakFoodItemsQty(clonebreakArry);
                    break;
                }
            }
        }
    };
    const addFoodItemToArry = (foodItem, mealType) => {
        let cloneFoodArry = JSON.parse(JSON.stringify(foodItem));
        //before adding check if it is in the array already..

        if (mealType === "BreakFastMeal") {
            //loop through it and set the value to
            let breakArry = [];
            for (let i = 0; i < foodItem.length; i++) {
                breakArry.push(1);
            }

            setFoodItemsArry(cloneFoodArry);
        }
        if (mealType === "LunchMeal") {
            setLunchFoodItemsArry(cloneFoodArry);
            let lunchArry = [];
            for (let i = 0; i < foodItem.length; i++) {
                //check if that index is undefined then push i to it
                lunchArry.push(1);
            }
            setLunchFoodItemsQty(lunchArry);
        }

        //add it to the array.
        if (mealType === "Dinner") {
            setDinnerFoodItemsArry(cloneFoodArry);
            let dinnerArry = [];
            for (let i = 0; i < foodItem.length; i++) {
                //check if that index is undefined then push i to it
                dinnerArry.push(1);
            }
            setDinnerFoodItemsQty(dinnerArry);
        }

        if (mealType === "Snack") {
            setSnackFoodItemsArry(cloneFoodArry);
            let snackArry = [];
            for (let i = 0; i < foodItem.length; i++) {
                //check if that index is undefined then push i to it
                snackArry.push(1);
            }
            setSnackFoodItemsQty(snackArry);
        }
    };

    const extractNameNutrientsValue = (arry, type) => {
        //loop through the arry
        let extractedResult = [];
        for (let i = 0; i < arry[type].length; i++) {
            let value = { name: arry[type][i].name, measure: arry[type][i].measure, quantity: arry[type][i].quantity, nutrients: arry[type][i].nutrients };
            extractedResult.push(value);
        }
        return extractedResult;
    };
    const lunchExtractQty = (arry, mealType) => {
        if (mealType === "LunchMeal") {
            let Lunchkeys = Object.keys(arry);
            let lunchQty = [];

            for (let i = 0; i < Lunchkeys.length; i++) {
                if (Lunchkeys[i].includes("Lunch", 0)) {
                    lunchQty.push(parseFloat(arry[Lunchkeys[i]]));
                }
            }

            return lunchQty;
        }
    };
    const extractQtyItem = (arry, mealType) => {
        if (mealType === "BreakFastMeal") {
            let keys = Object.keys(arry);
            let storeQty = [];
            for (let i = 0; i < keys.length; i++) {
                if (keys[i].includes("unit", 0)) {
                    storeQty.push(parseFloat(arry[keys[i]]));
                }
            }

            return storeQty;
        }
        if (mealType === "LunchMeal") {
            let lunchQty = [];
            let Lunchkeys = Object.keys(arry);
            for (let i = 0; i < Lunchkeys.length; i++) {
                if (Lunchkeys[i].includes("Lunch", 0)) {
                    lunchQty.push(parseFloat(arry[Lunchkeys[i]]));
                }
            }

            lunchQty.shift();

            return lunchQty;
        }
        //for dinner...
        if (mealType === "Dinner") {
            let dinnerQty = [];
            let dinnerkeys = Object.keys(arry);
            for (let i = 0; i < dinnerkeys.length; i++) {
                if (dinnerkeys[i].includes("Dinner", 0)) {
                    dinnerQty.push(parseFloat(arry[dinnerkeys[i]]));
                }
            }

            dinnerQty.shift();
            dinnerQty.shift();

            return dinnerQty;
        }

        if (mealType === "Snack") {
            let snackQty = [];
            let snackkeys = Object.keys(arry);
            for (let i = 0; i < snackkeys.length; i++) {
                if (snackkeys[i].includes("Snack", 0)) {
                    snackQty.push(parseFloat(arry[snackkeys[i]]));
                }
            }

            snackQty.shift();
            snackQty.shift();

            return snackQty;
        }
    };

    const multiplyNutrientValues = (arry, mealType) => {
        if (mealType === "BreakFastMeal") {
            let entersValues = extractQtyItem(arry, mealType);
            //loop through the mealtype.
            for (let k = 0; k < arry[mealType].length; k++) {
                for (let i = 0; i < arry[mealType][k].nutrients.length; i++) {
                    arry[mealType][k].nutrients[i].value = arry[mealType][k].nutrients[i].value * entersValues[k];
                    //add the quantity...
                    arry[mealType][k]["quantity"] = entersValues[k];
                }
            }
            return arry;
        }
        if (mealType === "LunchMeal") {
            let entersLunchValues = extractQtyItem(arry, mealType);
            //loop through the mealtype.
            for (let k = 0; k < arry[mealType].length; k++) {
                for (let i = 0; i < arry[mealType][k].nutrients.length; i++) {
                    arry[mealType][k].nutrients[i].value = arry[mealType][k].nutrients[i].value * entersLunchValues[k];
                    arry[mealType][k]["quantity"] = entersLunchValues[k];
                }
            }
            return arry;
        }
        if (mealType === "Dinner") {
            let entersLunchValues = extractQtyItem(arry, mealType);
            //loop through the mealtype.
            for (let k = 0; k < arry[mealType].length; k++) {
                for (let i = 0; i < arry[mealType][k].nutrients.length; i++) {
                    arry[mealType][k].nutrients[i].value = arry[mealType][k].nutrients[i].value * entersLunchValues[k];
                    arry[mealType][k]["quantity"] = entersLunchValues[k];
                }
            }
            return arry;
        }

        if (mealType === "Snack") {
            let entersSnackValues = extractQtyItem(arry, mealType);
            //loop through the mealtype.
            for (let k = 0; k < arry[mealType].length; k++) {
                for (let i = 0; i < arry[mealType][k].nutrients.length; i++) {
                    arry[mealType][k].nutrients[i].value = arry[mealType][k].nutrients[i].value * entersSnackValues[k];
                    arry[mealType][k]["quantity"] = entersSnackValues[k];
                }
            }
            return arry;
        }
    };

    const submitDailyMealPlan = (e) => {
        let breakFastFoodItems = [];
        let lunchFoodItems = [];
        let dinnerFoodItems = [];
        let snackFoodItems = [];
        let otherFoodItems = [];
        let plans = [];
        //capture them and store each food item in the exact meal plan array.
        if (e) {
            try {
                if (e.BreakFastMeal && e.BreakFastMeal.length >= 1) {
                    // let clonk = JSON.parse(JSON.stringify(e));
                    let calBreakFastCalories = multiplyNutrientValues(e, "BreakFastMeal");

                    breakFastFoodItems = extractNameNutrientsValue(calBreakFastCalories, "BreakFastMeal");

                    let breakFastData = {
                        mealType: 2,
                        meal: breakFastFoodItems,
                        recipe: { title: e.breakfastRecipeTitle, content: e.breakFastrecipe },
                    };
                    plans.push(breakFastData);
                }
                if (e.LunchMeal && e.LunchMeal.length >= 1) {
                    let calLunchCalories = multiplyNutrientValues(e, "LunchMeal");
                    lunchFoodItems = extractNameNutrientsValue(calLunchCalories, "LunchMeal");

                    let lunchData = {
                        mealType: 3,
                        meal: lunchFoodItems,
                        recipe: { title: e.lunchRecipeTitle, content: e.lunchrecipe },
                    };
                    plans.push(lunchData);
                }
                if (e.Dinner && e.Dinner.length >= 1) {
                    let calDinnerCalories = multiplyNutrientValues(e, "Dinner");
                    dinnerFoodItems = extractNameNutrientsValue(calDinnerCalories, "Dinner");

                    let dinnerData = {
                        mealType: 4,
                        meal: dinnerFoodItems,
                        recipe: { title: e.dinnerRecipeTitle, content: e.Dinnerrecipe },
                    };
                    plans.push(dinnerData);
                }

                if (e.Snack && e.Snack.length >= 1) {
                    let calSnackCalories = multiplyNutrientValues(e, "Snack");
                    snackFoodItems = extractNameNutrientsValue(calSnackCalories, "Snack");

                    let snackData = {
                        mealType: 5,
                        meal: snackFoodItems,
                        recipe: { title: e.snackRecipeTitle, content: e.Snackrecipe },
                    };
                    plans.push(snackData);
                }

                if (e.Others && e.Others.length >= 1) {
                    let calOthersCalories = multiplyNutrientValues(e, "Others");
                    otherFoodItems = extractNameNutrientsValue(calOthersCalories, "Others");

                    let otherData = {
                        mealType: 1,
                        meal: otherFoodItems,
                        recipe: { title: e.otherRecipeTitle, content: e.Otherrecipe },
                    };
                    plans.push(otherData);
                }

                let submittedData = {
                    day: days,
                    plan: plans,
                };

                handleSubmit(submittedData, days);

                // please check for null of each items
            } catch (e) {
                console.error(e);
            }
        }
    };

    const showMealPlanForm = (mealType) => {
        setNewAddArray((newAddArray) => [...newAddArray, mealType]);
    };

    const removeMealPlanTypeFromSelect = (meal) => {
        setMealTypes(mealType.filter((e) => e.key !== meal));
    };

    const onChange = (e) => {
        try {
          
            setDisableSaveButton(false);
            showMealPlanForm(e.key);
            removeMealPlanTypeFromSelect(e.key);
        } catch (e) {
            console.error(e);
        }
    };
    const enableButton = () => {
        setCanSubmit(true);
    };
    const disableButton = () => {
        setCanSubmit(false);
    };

    const removeMealPlanType = (meal, key) => {
        if (meal === "BreakFast") {
            setBreakFast({ key: "BreakFast", value: null });
        }
        if (meal === "Lunch") {
            setLunch({ key: "Lunch", value: null });
        }

        if (meal === "Snack") {
            setSnack({ key: "Snack", value: null });
        }
        if (meal === "Dinner") {
            setDinner({ key: "Dinner", value: null });
        }

        if (meal === "Others") {
            setOthersMealType({ key: "Others", value: null });
        }

        //remove from the new add array
        setNewAddArray(newAddArray.filter((e) => e !== meal));
        //add it back to setNutrients fields.
        setMealTypes([...mealType, { key: meal, value: key }]);
    };

    useEffect(() => {
        if (submitted) {
            totalResetAfterSubmitting();
            dailyReset();

            //add the day here and then check if it equal to the totalday
            if (days <= totalNumDays) {
                setDays(days + 1);
            }
        }
    }, [submitted]);
    return (
        <React.Fragment>
            <Formsy ref={dailyMealFormRef} onValidSubmit={submitDailyMealPlan} onValid={enableButton} onInvalid={disableButton} noValidate>
                {formError && !formError.errors ? <UncontrolledAlert color="danger">{formError.message}</UncontrolledAlert> : null}
                {formError && formError.errors ? (
                    <UncontrolledAlert color="danger">
                        {formError.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
                <Row>
                    <Col sm="4" style={{ marginLeft: "10rem" }}>
                        {days <= totalNumDays ? `Day ${days}` : null}
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md={{ size: 6, offset: 3 }}>
                        {false ? <span className="addFoodItem"> {<MdAdd size="1em" onClick={() => showConfirmation()} />}</span> : null}
                        {days <= totalNumDays ? <MySelect isMulti={false} name={"meal"} isClearable={false} onChange={onChange} title={"Select your meal type"} options={mealType} valueKey="value" labelKey="key" isRequired={true} defaultOptions={null} /*value={mealType}*/ /> : null}

                        {days <= totalNumDays ? (
                            newAddArray.map((mealPlanType, index) =>
                                mealPlanType === "BreakFast" ? (
                                    <Card className="mb-4" id={index}>
                                        <CardHeader>
                                            <span style={{ marginRight: "20rem" }}>{mealPlanType} </span>
                                            {<MdClose className="remove-icon" onClick={() => removeMealPlanType(mealPlanType, index)} style={{ cursor: "pointer", color: "red" }} />}
                                        </CardHeader>
                                        <CardBody>
                                            <AsyncFoodLibraryDropDown isMulti={true} isClearable={true} name="BreakFastMeal" title="Select food item" value={null} selectedMetrics valueKey="id" isRequired={true} addFoodItemToArry={addFoodItemToArry} mealModulus={true} />
                                            {foodItemsArry.map((e, index) => (
                                                <Card className="mb-2">
                                                    <CardBody>
                                                        <Row className="measurementSpaces mb-2">
                                                            <Col>
                                                                {" "}
                                                                <small>{"Food Item"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Metric Unit"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Quantity"}</small>
                                                            </Col>
                                                        </Row>
                                                        <Row className="measurementSpaces">
                                                            <Col>
                                                                <small>{e && e.name}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{e && e.measure}</small>
                                                            </Col>
                                                            <Col>
                                                                <TextInput
                                                                    id={`unit${index}`}
                                                                    name={`unit${index}`}
                                                                    required
                                                                    value={"1"}
                                                                    validations={{
                                                                        isNumeric: true,
                                                                         matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                    }}
                                                                    validationErrors={{
                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                    }}
                                                                    onChange={(e) => storeCalorieValue(e, index, "BreakFastMeal")}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            ))}
                                            <TextInput
                                                name={`breakfastRecipeTitle`}
                                                required
                                                title="Recipe Title"
                                                validations={{
                                                    minLength: 5,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 5 characters allowed",
                                                    maxLength: "Maximum of 50 characters allowed",
                                                }}
                                            />
                                            <MealRoasterEditor
                                                name="breakFastrecipe"
                                                value={null}
                                                required
                                                disabled={submitting}
                                                validations={{
                                                    minLength: 13,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 3 characters allowed",
                                                }}
                                                toolbarHidden={false}
                                                submitSucessful={submitted}
                                                submitting={submitting}
                                                title="Details of your Recipe"
                                                stripPastedStyles={true}
                                            />
                                        </CardBody>
                                    </Card>
                                ) : mealPlanType === "Lunch" ? (
                                    <Card className="mb-4" id={index}>
                                        <CardHeader>
                                            <span style={{ marginRight: "20rem" }}>{mealPlanType} </span>
                                            {<MdClose className="remove-icon" onClick={() => removeMealPlanType(mealPlanType, index)} style={{ cursor: "pointer", color: "red" }} />}
                                        </CardHeader>
                                        <CardBody>
                                            <AsyncFoodLibraryDropDown isMulti={true} isClearable={true} name="LunchMeal" title="Select food item" value={null} selectedMetrics valueKey="id" isRequired={true} addFoodItemToArry={addFoodItemToArry} mealModulus={true} />
                                            {lunchFoodItemsArry.map((e, index) => (
                                                <Card className="mb-2">
                                                    <CardBody>
                                                        <Row className="measurementSpaces mb-2">
                                                            <Col>
                                                                {" "}
                                                                <small>{"Food Item"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Metric Unit"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Quantity"}</small>
                                                            </Col>
                                                        </Row>
                                                        <Row className="measurementSpaces">
                                                            <Col>
                                                                <small>{e && e.name}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{e && e.measure}</small>
                                                            </Col>
                                                            <Col>
                                                                <TextInput
                                                                    id={`Lunch${index}`}
                                                                    name={`Lunch${index}`}
                                                                    required
                                                                    value={"1"}
                                                                    validations={{
                                                                        isNumeric: true,
                                                                         matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                    }}
                                                                    validationErrors={{
                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            ))}
                                            <TextInput
                                                name={`lunchRecipeTitle`}
                                                required
                                                title="Recipe Title"
                                                validations={{
                                                    minLength: 5,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 5 characters allowed",
                                                    maxLength: "Maximum of 50 characters allowed",
                                                }}
                                            />
                                            <MealRoasterEditor
                                                name="lunchrecipe"
                                                value={null}
                                                required
                                                disabled={submitting}
                                                validations={{
                                                    minLength: 13,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 3 characters allowed",
                                                }}
                                                toolbarHidden={false}
                                                submitSucessful={submitted}
                                                submitting={submitting}
                                                title="Details of your Recipe"
                                                stripPastedStyles={true}
                                            />
                                        </CardBody>
                                    </Card>
                                ) : mealPlanType === "Dinner" ? (
                                    <Card className="mb-4" id={index}>
                                        <CardHeader>
                                            <span style={{ marginRight: "20rem" }}>{mealPlanType} </span>
                                            {<MdClose className="remove-icon" onClick={() => removeMealPlanType(mealPlanType, index)} style={{ cursor: "pointer", color: "red" }} />}
                                        </CardHeader>
                                        <CardBody>
                                            <AsyncFoodLibraryDropDown isMulti={true} isClearable={true} name="Dinner" title="Select food item" value={null} selectedMetrics valueKey="id" isRequired={true} addFoodItemToArry={addFoodItemToArry} mealModulus={true} />
                                            {dinnerFoodItemsArry.map((e, index) => (
                                                <Card className="mb-2">
                                                    <CardBody>
                                                        <Row className="measurementSpaces mb-2">
                                                            <Col>
                                                                {" "}
                                                                <small>{"Food Item"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Metric Unit"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Quantity"}</small>
                                                            </Col>
                                                        </Row>
                                                        <Row className="measurementSpaces">
                                                            <Col>
                                                                <small>{e && e.name}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{e && e.measure}</small>
                                                            </Col>
                                                            <Col>
                                                                <TextInput
                                                                    id={`Dinner${index}`}
                                                                    name={`Dinner${index}`}
                                                                    required
                                                                    value={"1"}
                                                                    validations={{
                                                                        isNumeric: true,
                                                                         matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                    }}
                                                                    validationErrors={{
                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            ))}
                                            <TextInput
                                                name={`dinnerRecipeTitle`}
                                                required
                                                title="Recipe Title"
                                                validations={{
                                                    minLength: 5,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 5 characters allowed",
                                                    maxLength: "Maximum of 50 characters allowed",
                                                }}
                                            />
                                            <MealRoasterEditor
                                                name="Dinnerrecipe"
                                                value={null}
                                                required
                                                disabled={submitting}
                                                validations={{
                                                    minLength: 13,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 3 characters allowed",
                                                }}
                                                toolbarHidden={false}
                                                submitSucessful={submitted}
                                                submitting={submitting}
                                                title="Details of your Recipe"
                                                stripPastedStyles={true}
                                            />
                                        </CardBody>
                                    </Card>
                                ) : mealPlanType === "Snack" ? (
                                    <Card className="mb-4" id={index}>
                                        <CardHeader>
                                            <span style={{ marginRight: "20rem" }}>{mealPlanType} </span>
                                            {<MdClose className="remove-icon" onClick={() => removeMealPlanType(mealPlanType, index)} style={{ cursor: "pointer", color: "red" }} />}
                                        </CardHeader>
                                        <CardBody>
                                            <AsyncFoodLibraryDropDown isMulti={true} isClearable={true} name="Snack" title="Select food item" value={null} selectedMetrics valueKey="id" isRequired={true} addFoodItemToArry={addFoodItemToArry} mealModulus={true} />
                                            {snackFoodItemsArry.map((e, index) => (
                                                <Card className="mb-2">
                                                    <CardBody>
                                                        <Row className="measurementSpaces mb-2">
                                                            <Col>
                                                                {" "}
                                                                <small>{"Food Item"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Metric Unit"}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{"Quantity"}</small>
                                                            </Col>
                                                        </Row>
                                                        <Row className="measurementSpaces">
                                                            <Col>
                                                                <small>{e && e.name}</small>
                                                            </Col>
                                                            <Col>
                                                                <small>{e && e.measure}</small>
                                                            </Col>
                                                            <Col>
                                                                <TextInput
                                                                    id={`Snack${index}`}
                                                                    name={`Snack${index}`}
                                                                    required
                                                                    value={"1"}
                                                                    validations={{
                                                                        isNumeric: true,
                                                                         matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                    }}
                                                                    validationErrors={{
                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            ))}
                                            <TextInput
                                                name={`snackRecipeTitle`}
                                                required
                                                title="Recipe Title"
                                                validations={{
                                                    minLength: 5,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 5 characters allowed",
                                                    maxLength: "Maximum of 50 characters allowed",
                                                }}
                                            />
                                            <MealRoasterEditor
                                                name="Snackrecipe"
                                                value={null}
                                                required
                                                disabled={submitting}
                                                validations={{
                                                    minLength: 13,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 3 characters allowed",
                                                }}
                                                toolbarHidden={false}
                                                submitSucessful={submitted}
                                                submitting={submitting}
                                                title="Details of your Recipe"
                                                stripPastedStyles={true}
                                            />
                                        </CardBody>
                                    </Card>
                                ) : mealPlanType === "Others" ? (
                                    <Card className="mb-4" id={index}>
                                        <CardHeader>
                                            <span style={{ marginRight: "20rem" }}>{mealPlanType} </span>
                                            {<MdClose className="remove-icon" onClick={() => removeMealPlanType(mealPlanType, index)} style={{ cursor: "pointer", color: "red" }} />}
                                        </CardHeader>
                                        <CardBody>
                                            <AsyncFoodLibraryDropDown isMulti={true} isClearable={true} name="Others" title="Select food item" value={null} selectedMetrics valueKey="id" isRequired={true} />
                                            <TextInput
                                                name={`otherRecipeTitle`}
                                                required
                                                title="Recipe Title"
                                                validations={{
                                                    minLength: 5,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 5 characters allowed",
                                                    maxLength: "Maximum of 50 characters allowed",
                                                }}
                                            />
                                            <MealRoasterEditor
                                                name="Otherrecipe"
                                                value={null}
                                                required
                                                disabled={submitting}
                                                validations={{
                                                    minLength: 13,
                                                }}
                                                validationErrors={{
                                                    minLength: "Minimum of 3 characters allowed",
                                                }}
                                                toolbarHidden={false}
                                                submitSucessful={submitted}
                                                submitting={submitting}
                                                title="Details of your Recipe"
                                                stripPastedStyles={true}
                                            />
                                        </CardBody>
                                    </Card>
                                ) : null
                            )
                        ) : (
                            <Button type="button" color="primary" disabled={!canSubmit || submitting} onClick={() => submitToAdmin()} style={{ marginLeft: "10rem" }}>
                                {submitting ? <Spinner size="sm" /> : <span>{"Submit for approval"}</span>}
                            </Button>
                        )}
                        {days <= totalNumDays ? (
                            <Button type="submit" color="primary" disabled={disableSaveButton || !canSubmit || submitting}>
                                {submitting ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <span>
                                        {"Save"} <MdSave size={20} />
                                    </span>
                                )}
                            </Button>
                        ) : null}
                    </Col>
                </Row>
            </Formsy>
            <FoodLibraryModal isOpen={showFoodItemModal} showModal={showConfirmation} />
        </React.Fragment>
    );
});

export default DailyMealPlan;
